import { ReloadOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { Alert, Button, Card, Table, Tag, Typography } from 'antd';
import { AiToolInfo, aiChatToolsApi } from '../../../api/aiAssistant';

/**
 * AI 助手已注册工具一览（只读）。
 * 数据来自后端 AiToolRegistry 实际注册的 bean，代码新增/下线工具后这里自动同步。
 */
export default function AiChatToolsCard() {
  const { data, loading, error, refresh } = useRequest(() => aiChatToolsApi.list());
  // 后端未部署新接口时可能返回非数组，防御处理避免 Table 崩掉整页
  const tools = Array.isArray(data) ? data : [];

  return (
    <Card
      title={`AI 助手工具注册情况（${tools.length} 个）`}
      extra={
        <Button size="small" icon={<ReloadOutlined />} onClick={refresh}>
          刷新
        </Button>
      }
    >
      {error && (
        <Alert
          type="error"
          showIcon
          message="工具列表加载失败"
          description={error.message || '请点击刷新重试'}
          style={{ marginBottom: 12 }}
        />
      )}
      <Table<AiToolInfo>
        rowKey="name"
        size="small"
        loading={loading}
        dataSource={tools}
        pagination={false}
        columns={[
          {
            title: '工具名',
            dataIndex: 'name',
            width: 240,
            render: (name: string) => <Typography.Text code>{name}</Typography.Text>,
          },
          {
            title: '实现类',
            dataIndex: 'beanClass',
            width: 220,
            render: (beanClass: string) => <Tag color="blue">{beanClass}</Tag>,
          },
          {
            title: '说明',
            dataIndex: 'description',
          },
        ]}
        expandable={{
          rowExpandable: () => true,
          expandedRowRender: (record) => (
            <pre style={{ margin: 0, fontSize: 12, whiteSpace: 'pre-wrap' }}>
              {JSON.stringify(record.parameters, null, 2)}
            </pre>
          ),
        }}
      />
    </Card>
  );
}
